var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"button icon md-bell notification",on:{"click":_vm.onOpenNotifsPanel}},[(_vm.notificationsCount > 0)?_c('span',{staticClass:"label badge red rounded"},[_vm._v(" "+_vm._s(_vm.newNotifsCount)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }